<template>
  <div>
    <div class="header">
      <div class="w1200 clearfix">
        <div class="header_l">
          <div style="float:left;margin-right:10px;"><img src="../../assets/led/clogo.png" width="25px" style="vertical-align: middle;"></div>
          欢迎光临志鹏供应链<em><img src="../../assets/led/zp_01.png"> 400-040-7890</em>
        </div>
        <div class="header_r">
          <a href="javascript:;" class="ewm_btn">手机版<em><img src="../../assets/images/qr000.png"></em></a>
          <em v-if="!current_user.id">
            <router-link :to="{path:'/Login',query: {return_url: return_url}}" class="login_btn">登录</router-link>
            <router-link :to="{path:'/Register'}" class="register_btn">注册</router-link>
          </em>
          <em v-else>
            <router-link :to="{path:'/MyOrder'}" class="wddd_btn">我的订单</router-link>
            <a href="javascript:;" class="login_btn" @click="logout">退出</a>
            <router-link :to="{path:'/PersonalData'}" style="color:#fff;">欢迎-{{current_user.name || current_user.tel}}</router-link>
          </em>
        </div>
      </div>
    </div>
    <div class="hxq_ppsp">
      <img src="../../assets/led/kj1.png" height="200px;" width="100%"/>
      <div class="hxq_fllb_sx">
        <ul class="card-panel">
          <li class="card-panel-li"><h2>{{warehouse.title}}</h2></li>
          <li class="card-panel-li">
            <div class="card-panel-text">
              备件种类:<count-to :start-val="0" :end-val="warehouse.goodsNumber" :duration="3600" class="card-panel-num" />
            </div>
          </li>
          <!-- <li class="card-panel-li">
            <div class="card-panel-text">
              备件货柜:<count-to :start-val="0" :end-val="warehouse.cabinetNumber" :duration="3000" class="card-panel-num" />
            </div>
          </li> -->
          <li style="float:right;">
            <el-button type="primary" icon="el-icon-edit" size="small" style="margin-right:30px;" plain @click="editWarehouse">
              <span look>编辑</span>
            </el-button>
          </li>
        </ul>
        <div class="hxq_ppsp_box" v-loading="qyloading">
          <ul class="container-ul">
            <li :class="cabcheck==index?'cabcheck':''" class="container-li" v-for="(item, index) in container" :key="index" @click="cabcheckfun(index)">
              {{ item.title }}<i class="el-icon-s-opportunity" style="color: #00dcff;font-size: 20px;" v-if="item.cabuplight"></i>
            </li>
          </ul>
          <div style="margin-top: 15px;box-shadow: 0px 2px 5px 0px rgb(155 154 154);" v-if="warehouse.title">
            <!-- <el-input placeholder="请输入搜索内容" v-model="searchSAP" style="width:70%">
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input> -->
            <el-select
              v-model="searchSAP"
              filterable
              remote
              :reserve-keyword="true"
              placeholder="请输入搜索内容"
              :remote-method="remoteMethod"
              style="width:70%"
              @change="selectGoods"
              :clearable="true"
              value-key="id"
              :loading="loading">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.title"
                :value="item">
              </el-option>
            </el-select>
            <div style="display:inline-block;margin-left:20px;">
              <el-radio-group v-model="lightColor" size="small" @change="changeColor">
                <el-radio-button :label="index" v-for="(item, index) in lightColorList" :key="index">{{item.color}}</el-radio-button>
              </el-radio-group>
            </div>
            <el-button type="primary" icon="el-icon-edit" size="small" style="margin-left:30px;" @click="editLight">
              <span v-show="editOrLook == 'look'">编辑</span>
              <span v-show="editOrLook == 'edit'">取消</span>
            </el-button>
            <router-link :to="{path:'/LedcontrolEdit'}" style="margin-left:20px;"><el-button type="primary" icon="el-icon-upload" size="small">添加</el-button></router-link>
          </div>
          <div style="display:-webkit-box;">
            <!-- 已选择 -->
            <div class="ledcar" style="border-right: 1px solid #ccc;" v-if="goodsTags.length || Havelight_goods.length">
              <el-tag
                :key="index"
                v-for="(tag,index) in goodsTags"
                closable
                style="margin-left: 10px;margin-top:10px;"
                @close="handleClose(tag,index)">
                {{tag.title}}
              </el-tag>
              <el-button type="primary" size="small" style="margin-left:30px;" v-if="upBotton" @click="upStoreGoods">点亮</el-button>
              <el-button type="primary" size="small" style="margin-left:15px;" v-if="upBotton" @click="mvStoreGoods">清空</el-button>
            </div>
            <!-- 已点亮 -->
            <div class="ledcar" v-if="Havelight_goods.length">
              <el-tag
                :key="index"
                v-for="(tag,index) in Havelight_goods"
                style="margin-left: 10px;margin-top:10px;"
                @close="handleClose(tag,index)">
                {{tag.title}}
              </el-tag>
              <el-button type="primary" size="small" style="margin-left:30px;" v-if="Havelight_goods.length" @click="mvupGoods">关闭</el-button>
            </div>
          </div>
          <!-- 货柜start -->
          <div class="container-data" v-show="editOrLook == 'look'">
            <div class="floor" v-for="(items,floor_index) in lattice" :key="floor_index" :style="'height: ' + 900 / form.hang + 'px;color: #fff;'">
              &nbsp;&nbsp;&nbsp;{{floor_index+1}}层
              <div class="thislie" v-for="(item, index) in items.lattice" :key="index" v-show="item.show" :style="'width:' + item.width + 'px;height:' + 760 / form.hang + 'px;line-height:' + 760 / form.hang + 'px'" @click="lightUp(item)">
                <el-tooltip placement="top" style="width:100%;height:100%;" :disabled="!item.sap">
                  <!-- :class="item.lightType?uplight:''" -->
                  <div slot="content">
                    名称：{{item.title}}<br/>
                    物料代码：{{item.sap}}<br/>
                    机型：{{item.type}}<br/>
                    供应商：{{item.supplier}}<br/>
                    价格：{{item.price}}<br/>
                    数量：{{item.number}}<br/>
                  </div>
                  <el-button :class="item.lightType?uplight:''" style="padding:5px; display: block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.title || index}}</el-button>
                </el-tooltip>
              </div>
            </div>
          </div>
          <!-- 货柜end -->
          <!-- 货柜编辑start -->
          <div class="container-data" v-show="editOrLook == 'edit'">
            <div class="floor" v-for="(items,floor_index) in lattice" :key="floor_index" :style="'height: ' + 900 / form.hang + 'px;color: #fff;'">
              &nbsp;&nbsp;&nbsp;{{floor_index+1}}层
              <div class="thislie" v-for="(item, index) in items.lattice" :key="index" v-show="item.show" :style="'width:' + item.width + 'px;height:' + 760 / form.hang + 'px;line-height:' + 760 / form.hang + 'px'">
              <!-- :class="item.lightType?uplight:''" -->
                <!-- <el-button type="text" @click="dialogfun(item)">产品绑定</el-button> -->
                <el-tooltip placement="top" style="width:100%;height:100%;" :disabled="!item.sap">
                  <div slot="content">
                    名称：{{item.title}}<br/>
                    物料代码：{{item.sap}}<br/>
                    价格：{{item.price}}<br/>
                    数量：{{item.number}}<br/>
                    机型：{{item.type}}<br/>
                    供应商：{{item.supplier}}<br/>
                  </div>
                  <el-button @click="dialogfun(item,floor_index,index)" style="padding:5px;display: block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.title || '编辑'}}</el-button>
                </el-tooltip>
              </div>
            </div>
          </div>
          <!-- 货柜编辑end -->
          <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="35%" @close="relievebind">
            <el-form ref="dataForm" :model="addGoods" :rules="rules" label-width="80px">
              <el-form-item label="产品名称" :label-width="formLabelWidth" prop="title">
                <el-input v-model="addGoods.title" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="物料代码" :label-width="formLabelWidth" prop="sap">
                <el-input v-model="addGoods.sap" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="机型">
                 <el-select v-model="addGoods.type" placeholder="请选择">
                    <el-option
                      v-for="item in typeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="供应商" :label-width="formLabelWidth" prop="supplier">
                <el-input v-model="addGoods.supplier" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="价格" :label-width="formLabelWidth" prop="price">
                <el-input v-model="addGoods.price" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="数量" :label-width="formLabelWidth" prop="number">
                <el-input v-model="addGoods.number" autocomplete="off"></el-input>
              </el-form-item>
              <!-- <el-form-item label="机型" :label-width="formLabelWidth" prop="type">
                <el-input v-model="addGoods.type" autocomplete="off"></el-input>
              </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="relievebind">取 消</el-button>
              <el-button type="danger" plain @click="deleteGoods" v-if="addGoods.gid">产品删除</el-button>
              <el-button type="warning" plain @click="CancelTheMerger" v-if="addGoods.merge > 1">取消合并</el-button>
              <el-button type="primary" @click="bindGoods">确 定</el-button>
            </div>
          </el-dialog>
          <div class="cght_cnxhtiwtjsp" v-show="false">
            <div>
              <em class="myemptydata">暂无数据</em>
            </div>
          </div>
          <el-dialog title="仓储信息" :visible.sync="dialogFormWarehouse" width="35%" @close="closeHouse">
            <el-form ref="dataForm" :model="warehouse" :rules="newrules" label-width="80px">
              <el-form-item label="仓库名称" :label-width="formLabelWidth" prop="title">
                <el-input v-model="warehouse.title" autocomplete="off"></el-input>
              </el-form-item>
              <!-- <el-form-item label="IP地址" :label-width="formLabelWidth" prop="topic">
                <el-input placeholder="请输入IP地址" v-model="warehouse.topic">
                </el-input>
              </el-form-item> -->
              <el-form-item label="货柜名称" :label-width="formLabelWidth" prop="title" v-for="(item,index) in warehouse.container" :key="index">
                <el-input v-model="item.title" autocomplete="off" style="width:85%;" maxlength="8"></el-input>
                <el-button type="" icon="el-icon-delete" circle style="margin-left:10px;" @click="deleteWarehouse(item.id)"></el-button>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="closeHouse">取 消</el-button>
              <el-button type="primary" @click="saveWarehouse">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import countTo from 'vue-count-to'
import api from '@/api/cabinet'
import mqtt from 'mqtt'
// import axios from 'axios'
export default {
  name: 'Ledcontrol',
  components: { countTo },
  data () {
    return {
      return_url: this.$route.fullPath,
      qyloading: false,
      searchSAP: '',
      container: [],
      subHouse: {},
      cabcheck: 0,
      lattice: [],
      form: {
        hang: 0
      },
      lightColor: 0,
      lightColorList: [
        {color: '青', numerical: {c1: 0, c2: 255, c3: 255}},
        {color: '红', numerical: {c1: 255, c2: 0, c3: 0}},
        {color: '绿', numerical: {c1: 0, c2: 255, c3: 0}},
        {color: '紫', numerical: {c1: 255, c2: 0, c3: 255}},
        {color: '白', numerical: {c1: 255, c2: 255, c3: 255}}
      ],
      uplight: 'uplightBlue',
      tone: {c1: 0, c2: 255, c3: 255}, // 开始默认灯颜色113 243 31
      editOrLook: 'look',
      dialogFormVisible: false,
      dialogFormWarehouse: false,
      addGoods: {
        title: '',
        sap: '',
        number: '',
        price: '',
        type: '',
        supplier: '',
        merge: ''
      },
      formLabelWidth: '80px',
      rules: {
        title: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        sap: [{ required: true, message: '请输入物料代码', trigger: 'blur' }]
      },
      newrules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        topic: [{ required: true, message: '请输入topic信息', trigger: 'blur' }]
      },
      floor_index: '',
      index: '',
      goodsTags: [], // 已选择要点亮的格子
      Havelight_goods: [], // 已经点亮的格子
      loading: false,
      options: [], // 搜索返回的产品
      upLattice: [],
      upBotton: false, // 点亮按钮
      warehouse: {
        id: '',
        title: '',
        topic: '',
        goodsNumber: 0,
        cabinetNumber: 0,
        container: []
      },
      client: {},
      mqttConfig: {
        prot: 8083,
        clientId: ''
      },
      timeOut: '',
      typeList: [{
        value: '暂无',
        label: '暂无'
      }, {
        value: '低温插管机',
        label: '低温插管机'
      }, {
        value: '低温封箱机',
        label: '低温封箱机'
      }, {
        value: '低温裹包机',
        label: '低温裹包机'
      }, {
        value: '低温开箱机',
        label: '低温开箱机'
      }, {
        value: '低温老酸奶/瓶酸',
        label: '低温老酸奶/瓶酸'
      }, {
        value: '低温前处理',
        label: '低温前处理'
      }, {
        value: '低温装箱机',
        label: '低温装箱机'
      }, {
        value: '低温Arcil',
        label: '低温Arcil'
      }, {
        value: '低温袋酸',
        label: '低温袋酸'
      }, {
        value: '低温公用',
        label: '低温公用'
      }, {
        value: '低温桶酸',
        label: '低温桶酸'
      }]
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getWarehouse()
    this.getCabinet()
    // this.connect()
    this.getlightup()
  },
  methods: {
    swapHotData: function () {
      // The Handsontable instance is stored under the `hotInstance` property of the wrapper component.

      // this.$refs.hotTableComponent.hotInstance.loadData([['new', 'data']])

      console.log(this.$refs.hotTableComponent.hotInstance.getPlugin('MergeCells').mergedCellsCollection.mergedCells)
    },
    // 点灯背景
    bglight () {
      this.lattice.map(res => {
        res.lattice.map(ron => {
          this.Havelight_goods.map(responter => {
            if (ron.id === responter.lattice_id) {
              ron.lightType = true
            }
          })
        })
      })
    },
    // 获取已经点亮的灯
    getlightup () {
      if (localStorage.getItem('Havelight')) {
        this.Havelight_goods = JSON.parse(localStorage.getItem('Havelight'))
      }
    },
    upGoods () {
      var latticeId = JSON.parse(localStorage.getItem('upLattice'))
      if (latticeId) {
        this.upBotton = true
        this.goodsTags = latticeId
      }
    },
    // 选择搜索返回值
    selectGoods () {
      var latticeId = JSON.parse(localStorage.getItem('upLattice'))
      if (!latticeId) {
        latticeId = []
        latticeId.push(this.searchSAP)
        localStorage.setItem('upLattice', JSON.stringify(latticeId))
        this.goodsTags = []
        this.upGoods()
      } else {
        var index = latticeId.findIndex(item => item.id === this.searchSAP.id)
        if (index === -1) {
          latticeId.push(this.searchSAP)
          localStorage.setItem('upLattice', JSON.stringify(latticeId))
          this.goodsTags = []
          this.upGoods()
        }
      }
    },
    // 单个取消选择
    handleClose (tag, index) {
      this.searchSAP = ''
      this.goodsTags.splice(index, 1)
      this.upLattice.splice(index, 1)
      if (this.goodsTags.length > 0) {
        localStorage.setItem('upLattice', JSON.stringify(this.goodsTags))
      } else {
        this.upBotton = false
        localStorage.removeItem('upLattice')
      }
      this.goodsTags = []
      this.upGoods()
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          api.getLedGoods({'keywords': query}).then(res => {
            this.options = res.items
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    async logout () {
      await this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' })
      }
    },
    // 切换柜子
    cabcheckfun (index) {
      if (this.cabcheck === index) {
        return false
      }
      this.cabcheck = index
      this.getCabinet(this.container[index])
    },
    // 获取柜子数据
    getCabinet (ckitem) {
      this.qyloading = true
      let id = ckitem ? ckitem.id : null
      api.getCabinet({id: id}).then(res => {
        res.items.map(rep => {
          rep.cabuplight = false
        })
        this.container = res.items
        this.$set(this.warehouse, 'container', JSON.parse(JSON.stringify(res.items)))
        // this.warehouse.container = JSON.parse(JSON.stringify(res.items))
        this.cabUpligCal()
        if (res.items.length > 0) {
          var nLattice = res.lattice
          this.lattice = nLattice
          this.lattice.map(res => {
            res.lattice.map(ron => {
              ron.lightType = false
            })
          })
          this.form.hang = ckitem ? ckitem.hang : res.items[0].hang // 行列必须存放新的变量，不然双向绑定计算出错
        }
        this.qyloading = false
        this.goodsTags = []
        this.upGoods()
        this.bglight()
      })
    },
    // 格子点击
    lightUp (light) {
      var para = {
        cabinet_id: light.cabinet_id,
        id: null,
        lattice_id: light.id,
        led_channel: light.led_channel,
        sap: light.sap,
        title: light.title ? light.title : this.container[this.cabcheck].title + (light.hang + 1) + '-' + (light.lie + 1),
        groupcab: light.groupcab,
        lednum: light.lednum
      }
      var latticeId = JSON.parse(localStorage.getItem('upLattice'))
      if (!latticeId) {
        latticeId = []
        latticeId.push(para)
        localStorage.setItem('upLattice', JSON.stringify(latticeId))
        this.goodsTags = []
        this.upGoods()
      } else {
        var index = latticeId.findIndex(item => item.title === para.title)
        if (index === -1) {
          latticeId.push(para)
          localStorage.setItem('upLattice', JSON.stringify(latticeId))
          this.goodsTags = []
          this.upGoods()
        }
      }
      // api.lightUp(para).then(res => {
      //   // console.info(res)
      // })
    },
    // 变色
    changeColor (value) {
      this.tone = this.lightColorList[value].numerical
      switch (value) {
        case 0:
          this.uplight = 'uplightBlue'
          break
        case 1:
          this.uplight = 'uplightRed'
          break
        case 2:
          this.uplight = 'uplightGreen'
          break
        case 3:
          this.uplight = 'uplightPurple'
          break
        case 4:
          this.uplight = 'uplightWhite'
          break
      }
    },
    // 编辑
    editLight () {
      if (this.editOrLook === 'edit') {
        this.editOrLook = 'look'
      } else {
        this.editOrLook = 'edit'
      }
    },
    // 产品绑定编辑提交
    bindGoods () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          api.bindGoods(this.addGoods).then(res => {
            this.relievebind()
            this.$message({
              message: '绑定成功',
              type: 'success'
            })
            Object.assign(this.lattice[this.floor_index].lattice[this.index], res.items)
          })
        }
      })
    },
    // Dialog 打开的回调
    dialogfun (item, floorIndex, index) {
      this.dialogFormVisible = true
      if (item.sap) {
        this.addGoods = item
      }
      this.addGoods.cabinet_id = item.cabinet_id
      this.addGoods.lattice_id = item.id
      this.addGoods.led_channel = (floorIndex + 1)
      this.addGoods.merge = item.merge
      this.floor_index = floorIndex
      this.index = index
    },
    // Dialog 关闭的回调
    relievebind () {
      this.dialogFormVisible = false
      this.addGoods = {
        title: '',
        sap: '',
        number: '',
        price: '',
        type: '',
        supplier: '',
        merge: ''
      }
    },
    // 仓库信息编辑
    editWarehouse () {
      this.dialogFormWarehouse = true
    },
    // 仓库Dialog关闭
    closeHouse () {
      this.dialogFormWarehouse = false
      this.warehouse = JSON.parse(JSON.stringify(this.subHouse))
      this.$set(this.warehouse, 'container', JSON.parse(JSON.stringify(this.container)))
    },
    // 编辑仓库信息
    saveWarehouse () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          for (var i = 0; i < this.warehouse.container.length; i++) {
            if (!this.warehouse.container[i]['title']) {
              this.$message.error('请填写货柜名称')
              return false
            }
          }
          api.editWarehouse(this.warehouse).then(res => {
            this.closeHouse()
            this.getWarehouse()
            this.getCabinet(this.container[this.cabcheck])
          })
        }
      })
    },
    // 获取仓库信息
    getWarehouse () {
      api.getWarehouse().then(res => {
        this.warehouse = res.item
        this.subHouse = JSON.parse(JSON.stringify(res.item))
      })
    },
    // 货柜删除
    deleteWarehouse (id) {
      this.$confirm('此操作将永久删除该货柜（包含该货柜中的产品）, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.deleteWarehouse({id: id}).then(res => {
          this.dialogFormWarehouse = false
          if (res.code === 20000) {
            this.getCabinet()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
      }).catch(() => {
      })
    },
    // 灯带点亮
    upStoreGoods () {
      // 判断灯珠数量是否达到330
      var Havelight = JSON.parse(localStorage.getItem('Havelight')) // 已点亮灯珠
      var upLattice = JSON.parse(localStorage.getItem('upLattice')) // 已选择灯珠
      var counts = 0
      if (Havelight) {
        Havelight = this.conantArray(Havelight)
        upLattice = this.conantArray(upLattice)
        Havelight.map(res => {
          upLattice.map(ee => {
            if (res.id === ee.id) {
              counts = res.list.length + ee.list.length
            }
          })
        })
      } else {
        upLattice = this.conantArray(upLattice)
        for (var i = 0; i < upLattice.length; i++) {
          if (upLattice[i].list.length > 300) {
            counts = upLattice[i].list.length
            this.$message.error('要点亮灯珠过多，请保护你的电源')
            return false
          }
        }
      }
      if (counts > 300) {
        this.$message.error('要点亮灯珠过多，请保护你的电源')
        return
      }
      this.warehouse.color = this.tone
      this.warehouse.goodsTags = this.goodsTags
      api.upStoreGoods(this.warehouse).then(res => {
        if (res.code === 20000) {
          this.upBotton = false
          var geziGoods = localStorage.getItem('upLattice')
          var latticeId = JSON.parse(localStorage.getItem('Havelight'))
          if (!latticeId) {
            latticeId = JSON.parse(geziGoods)
            localStorage.setItem('Havelight', geziGoods)
          } else {
            JSON.parse(geziGoods).map(rep => {
              var index = latticeId.findIndex(item => item.title === rep.title)
              if (index === -1) {
                latticeId.push(rep)
                localStorage.setItem('Havelight', JSON.stringify(latticeId))
              }
            })
          }
          localStorage.removeItem('upLattice')
          this.goodsTags = []
          this.Havelight_goods = latticeId
          this.cabUpligCal()
          // var _this = this
          // this.timeOut = setTimeout(function () {
          //   _this.mvupGoods()
          // }, 100000)
          this.bglight()
        }
      })
    },
    // 柜子亮灯样式计算显示
    cabUpligCal () {
      let gropArr = []
      for (var i = 0; i < this.Havelight_goods.length; i++) {
        if (gropArr.indexOf(this.Havelight_goods[i].cabinet_id) === -1) {
          gropArr.push(this.Havelight_goods[i].cabinet_id)
        }
      }
      gropArr.map(aa => {
        this.container.map(bb => {
          if (aa === bb.id) {
            bb.cabuplight = true
          }
        })
      })
    },
    // 数组计算
    conantArray (Array) {
      let tempArr = []
      let newArr = []
      for (var i = 0; i < Array.length; i++) {
        if (tempArr.indexOf(Array[i].groupcab) === -1) {
          newArr.push({
            id: Array[i].groupcab,
            list: Array[i].lednum.split(',')
          })
          tempArr.push(Array[i].groupcab)
        } else {
          for (let j = 0; j < newArr.length; j++) {
            if (newArr[j].id === Array[i].groupcab) {
              newArr[j].list = newArr[j].list.concat(Array[i].lednum.split(','))
            }
          }
        }
      }
      return newArr
    },
    // 清空选择的产品格子
    mvStoreGoods () {
      this.upBotton = false
      localStorage.removeItem('upLattice')
      this.goodsTags = []
    },
    // 关闭已点亮的灯
    mvupGoods () {
      this.warehouse.color = null
      this.warehouse.goodsTags = JSON.parse(localStorage.getItem('Havelight'))
      if (this.warehouse.goodsTags) {
        api.upStoreGoods(this.warehouse).then(res => {
          if (res.code === 20000) {
            localStorage.removeItem('Havelight')
            this.Havelight_goods = []
            this.container.map(rep => {
              rep.cabuplight = false
            })
          }
          this.lattice.map(res => {
            res.lattice.map(ron => {
              ron.lightType = false
            })
          })
        })
      }
    },
    // 产品删除，接触绑定
    deleteGoods () {
      if (this.addGoods.gid) {
        this.$confirm('是否删除该产品?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.deleteGoods(this.addGoods).then(res => {
            this.dialogFormVisible = false
            if (res.code === 20000) {
              this.getCabinet()
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
        }).catch(() => {
        })
      }
    },
    // 取消合并
    CancelTheMerger () {
      if (this.addGoods.gid) {
        this.$message.error('有产品存在不可取消合并')
        return false
      }
      if (this.addGoods.merge > 1) {
        this.$confirm('是否取消合并?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.CancelTheMerger(this.addGoods).then(res => {
            this.dialogFormVisible = false
            if (res.code === 20000) {
              this.getCabinet(this.container[this.cabcheck])
              this.$message({
                type: 'success',
                message: '合并已取消!'
              })
            }
          })
        }).catch(() => {
        })
      }
    },
    subscribe () {

    },
    connect () {
      let options = {
        username: 'admin',
        password: '130150',
        cleanSession: false,
        keepAlive: 60,
        clientId: 'scy-mqtt-client',
        connectTimeout: 4000
      }
      this.client = mqtt.connect('ws://39.104.97.120:8083/mqtt', options)
      this.client.on('connect', (e) => {
        console.log('成功连接服务器:', e)
        // 订阅三个名叫'top/#', 'three/#'和'#'的主题
        this.client.subscribe(['what/this', 'home/devices/onoff/', '#'], { qos: 1 }, (err) => {
          if (!err) {
            console.log('订阅成功')
            // 向主题叫“pubtop”发布一则内容为'hello,this is a nice day!'的消息
            this.publish('home/devices/onoff/', 'hello,this is a nice day!')
          } else {
            console.log('消息订阅失败！')
          }
        })
      })
      // 重新连接
      this.reconnect()
      // 是否已经断开连接
      this.mqttError()
      // 监听获取信息
      this.getMessage()
    },
    // 监听接收消息
    getMessage () {
      this.client.on('message', (topic, message) => {
        if (message) {
          console.log('收到来着', topic, '的信息', message.toString())
          const res = JSON.parse(message.toString())
          console.log(res, 'res')
          this.msg = message
        }
      })
    },
    // 监听服务器是否连接失败
    mqttError () {
      this.client.on('error', (error) => {
        console.log('连接失败：', error)
        this.client.end()
      })
    },
    // 监听服务器重新连接
    reconnect () {
      this.client.on('reconnect', (error) => {
        console.log('正在重连:', error)
      })
    },
    // 发布消息@topic主题  @message发布内容
    publish (topic, message) {
      if (!this.client.connected) {
        console.log('客户端未连接')
        return
      }
      this.client.publish(topic, message, {qos: 1}, (err) => {
        if (!err) {
          console.log('主题为' + topic + '发布成功')
        }
      })
    }
  }
}
</script>
<style scoped>
.ledcar{
  margin-top: 20px;
  width:49.5%;
  float: left;
}
.uplightRed{
  background-color: rgb(255, 0, 0);
  color:azure;
}
.uplightGreen{
  background-color: rgb(0, 255, 0);
  color:azure;
}
.uplightBlue{
  background-color: rgb(0, 255, 255);
}
.uplightPurple{
  background-color: rgb(255, 0, 255);
  color:azure;
}
.uplightWhite{
  background-color: rgb(151, 151, 151);
  color:azure;
}
.uplight.el-button--text{
  color:azure;
}
.cabcheck{
  background: #1f91f3;
  box-shadow: 0px 3px 6px 0px #1f91f3 !important;
  color:#fff;
}
.floor{
  width: 100%;
  height: 60px;
  background:url('../../assets/led/banzi.png') no-repeat;
  background-position:bottom;
  display: inline-block;
  background-size: contain;
}
.floor:first-child{
  margin-top:21px;
}
.container-data{
  width: 1600px;
  height: 933px;
  margin-top:20px;
  background:url('../../assets/led/containerBg.png') no-repeat;
  background-size:cover;
}
.container-ul{
  width: 1600px;
}
.container-li{
  width:120px;
  word-wrap:break-word;
  word-break:break-all;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  margin-top:15px;
  box-shadow: 0px 3px 6px 0px rgb(155, 154, 154);
}
.thislie{
  word-wrap:break-word;
  word-break:break-all;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  border-right: 1px solid #ccc;
}
.thislie:first-child{
  margin-left: 14px;
}
.container-data .floor:last-child .thislie:first-child{
  /* margin-left: 5px; */
}
.thislie:last-child{
  border:none;
}
.card-panel{
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #b5b5b5;
  box-shadow:0px 0px 5px 1px rgb(155, 154, 154);
  margin-top:10px;
}
.card-panel-li{
  float:left;
  margin-left: 20px;
}
.card-panel-li:first-child{
  border-right: 1px solid #ccc;
  padding-right: 15px;
}
.card-panel-text{
  font-weight: bold;
  font-size: 18px;
}
.card-panel-num{
  color:#409EFF;
  font-weight: bold;
}
.hxq_fllb_sx{
  width: 1600px;
  margin: 0 auto;
}
.header_l{
  color:#fff;
}
.header_l em{
  color: #fe722c;
}
.header_r a.wddd_btn:hover{
  color:#0f6efd;
}
.header_r a.login_btn:hover{
  color:#0f6efd;
}
.header_r a.ewm_btn:hover{
  color:#0f6efd;
}
.header{
  position: fixed;
  right: 0;
  left: 0;
  background: #29293e;
}
.header_r a{
  color:#b5b5b5;
}
</style>



// WEBPACK FOOTER //
// src/view/led/ledcontrol.vue